import { render } from "./PricingPage.vue?vue&type=template&id=15114c1c&ts=true"
import script from "./PricingPage.vue?vue&type=script&lang=ts"
export * from "./PricingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__